<template>
  <b-navbar fixed-top spaced shadow class="is-white">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          src="@/assets/logo_minedu.png"
          alt="Placeholder logo"
        >
      </b-navbar-item>

      <b-navbar-item>
        <strong> {{ $t('components.navigationBar.brandingText') }} </strong>
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-dropdown>
        <div slot="label">
          <b-icon icon="earth"></b-icon>
          <span>
            {{ $t('components.navigationBar.localeChanger.language') }}
          </span>
        </div>
        <b-navbar-item
          v-for="(locale, i) in locales"
          :key="i"
          class="has-text-justified"
          @click="changeLocale(locale.code)"
        >
          <img :src="locale.flag" :alt="locale.code">
          <span>
            {{ locale.name }}
          </span>
        </b-navbar-item>
      </b-navbar-dropdown>
    </template>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NavigationBarAnonymous',
  data () {
    return {
      locales: (this.$i18n.availableLocales).map(item => ({
        code: item,
        flag: require('@/assets/' + item + '.svg'),
        name: this.$i18n.messages[item].common.locale.nativeName
      }))
    }
  },
  methods: {
    ...mapActions([
      'setLocale'
    ]),
    ...mapGetters([
      'getLocale'
    ]),
    changeLocale (code) {
      this.$i18n.locale = code
      this.setLocale(code)
    }
  }
}
</script>
